import { debounce } from '../../functions/debounce';
import { initEditModeTogglers } from './editmode-toggler';
import { checkForDuplicateIds } from './check-for-duplicate-ids';
function initForm(form) {
    const spinner = form.querySelector('.spv-spinner');
    if (!spinner) {
        console.warn('No spinner found in form');
        return;
    }
    spinner.setAttribute('aria-live', 'polite');
    const action = form.getAttribute('action');
    if (!action) {
        console.warn('Form had no action!', form);
        return;
    }
    const statusMessage = document.createElement('div');
    statusMessage.classList.add('spv-screenreader', 'svp-statusMessage');
    statusMessage.setAttribute('role', 'status');
    statusMessage.setAttribute('aria-live', 'polite');
    statusMessage.setAttribute('aria-atomic', 'true');
    form.appendChild(statusMessage);
    console.debug('initForm', form);
    const method = form.getAttribute('method');
    const inputs = form.getElementsByTagName('input');
    const onSubmit = async (e) => {
        e.preventDefault();
        if (!form.reportValidity()) {
            console.debug('On submit, form is not valid');
            return;
        }
        console.debug('On submit, form is valid');
        spinner.classList.remove('spv-spinner--done');
        spinner.classList.add('spv-spinner--active');
        statusMessage.innerText = '';
        const data = new FormData(form);
        const response = await fetch(action, {
            method: method || 'POST',
            body: data,
        });
        if (response.ok) {
            statusMessage.innerText = 'Lagret!';
            setTimeout(() => {
                spinner.classList.remove('spv-spinner--active');
                spinner.classList.add('spv-spinner--done');
            }, 200);
            setTimeout(() => {
                spinner.classList.remove('spv-spinner--done');
                statusMessage.innerText = '';
            }, 5000);
        }
    };
    form.addEventListener('submit', onSubmit);
    const debouncedSubmit = debounce(() => onSubmit(new Event('submit')));
    const debouncedSubmitLong = debounce(() => onSubmit(new Event('submit')), 500);
    const onLetterTyped = function (ev) {
        if (ev.key?.length === 1 || ev.key === 'Backspace' || ev.key === 'Delete') {
            console.debug('Printable keyup ', ev.key);
            debouncedSubmitLong();
        }
        else {
            if (ev.key) {
                console.debug('Non printable keyup key:', ev.key);
            }
            else {
                console.debug('Non printable keyup no key attribute', ev);
            }
        }
    };
    const onTextInputChanged = function (ev) {
        console.debug('Text input changed', ev);
        debouncedSubmitLong();
    };
    const onOtherInputChanged = function (ev) {
        console.debug('Form element changed', ev);
        debouncedSubmit();
    };
    const arrayOfInputs = Array.from(inputs);
    arrayOfInputs.forEach((input) => {
        switch (input.type) {
            case 'text':
            case 'url':
            case 'email':
            case 'tel':
            case 'textarea':
                input.addEventListener('keyup', onLetterTyped);
                input.addEventListener('change', onTextInputChanged);
                break;
            default:
                input.addEventListener('change', onOtherInputChanged);
                break;
        }
    });
    const deleteButton = form.querySelector('[data-delete-action]');
    if (deleteButton) {
        const deleteAction = deleteButton.dataset.deleteAction;
        const onDelete = async (e) => {
            if (!deleteAction) {
                console.warn('No delete action found, using fallback');
                return;
            }
            e.preventDefault();
            if (!confirm('Er du sikker på at du vil slette?')) {
                return;
            }
            spinner.classList.remove('spv-spinner--done');
            spinner.classList.add('spv-spinner--active');
            statusMessage.innerText = '';
            const data = new FormData(form);
            const response = await fetch(deleteAction, {
                method: method || 'POST',
                body: data,
            });
            if (response.ok) {
                statusMessage.innerText = 'Slettet!';
                form.classList.add('spv-autosavedForm--deleting');
                setTimeout(() => {
                    form.remove();
                }, 2550);
            }
        };
        deleteButton.addEventListener('click', onDelete);
    }
}
export default function initAutoSavedForms() {
    const forms = document.querySelectorAll('.spv-autosavedForm');
    console.debug('initAutoSavedForms', forms);
    forms.forEach(form => {
        initForm(form);
    });
}
function initValidation() {
    const forms = document.querySelectorAll('.spv-validate');
    forms.forEach(form => {
        form.addEventListener('submit', e => {
            if (!form.reportValidity()) {
                e.preventDefault();
            }
        });
    });
}
window.addEventListener('DOMContentLoaded', () => {
    console.debug('DOMContentLoaded AUTOSAVED FORMS');
    initAutoSavedForms();
    initValidation();
    initEditModeTogglers();
    checkForDuplicateIds();
});
//# sourceMappingURL=autosavedform.js.map